import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getToken, PLAN_INACTIVE_CODE, PLAN_INACTIVE_MESSAGE, removeToken } from "../shared/helpers/localstorage-helper";
import { useEffect } from "react";
import { getMe } from "../features/search/service/user-service";

interface ProtectedRouteProps {
  allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = getToken();

  useEffect(() => {
    if (token === null) {
        removeToken();
        navigate("/", { replace: true });
    }
  }, [token, navigate]);

  useEffect(() => {
    if (token === null) {
      return;
    }

    let isMounted = true;

    const validateSession = async () => {
      try {
        await getMe();
      } catch (error) {
        const sessionError = error as Error & { code?: string; status?: number };

        if (isMounted && (sessionError.code === PLAN_INACTIVE_CODE || sessionError.status === 403)) {
          removeToken();
          navigate("/", {
            replace: true,
            state: { error: PLAN_INACTIVE_MESSAGE }
          });
        }
      }
    };

    validateSession();

    return () => {
      isMounted = false;
    };
  }, [location.pathname, navigate, token]);
  
  if (token === null) {
    return null;
  }

  return <Outlet />;
};

export default ProtectedRoute;
